module.exports = __webpack_public_path__ + "svg/mygreen-blue.svg?0c8d25b6c65c0bee5a06a797b7f3528c";